import { render, staticRenderFns } from "./ListSasv.vue?vue&type=template&id=6d4056a4"
import script from "./ListSasv.vue?vue&type=script&lang=js"
export * from "./ListSasv.vue?vue&type=script&lang=js"
import style0 from "./ListSasv.vue?vue&type=style&index=0&id=6d4056a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports